import { helper } from '@/utils'

export default {
  methods: {
    failedCallback (error) {
      this.saving = false
      helper.showErrorMessage(this, this.component, error)
    },
    fieldType (type) {
      return type || 'text'
    },
    isText (type) {
      return this.fieldType(type) === 'text'
    },
    isTextarea (type) {
      return this.fieldType(type) === 'textarea'
    },
    successCallback () {
      this.saving = false
      this.$message({
        message: this.$t('messageLegalSave'),
        showClose: true,
        type: 'success'
      })
    },
    submit () {
      return this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.updateLegal()
          }
        })
    },
    updateLegal () {
      this.saving = true
      const text = this.data.text
      const data = {}
      for (const key in text) {
        data[key] = text[key].model
      }

      return this.$api.updateLegal(data)
        .then(
          () => this.successCallback(),
          (e) => this.failedCallback(e)
        )
    }
  },
  name: 'ThemeLegal',
  props: {
    loading: { default: true, type: Boolean },
    text: { type: Object, required: true },
    title: String
  },
  data () {
    return {
      component: 'themeLegal',
      data: {
        text: this.text
      },
      labelWidth: '200px',
      saving: false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ThemeLegal/ThemeLegal.js